import * as React from 'react'
import { Flex } from 'rebass'
import Helmet from 'react-helmet'
import * as Robot from '../assets/robot.svg'

class BlogIndex extends React.Component {
  render() {
    return (
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
        flexDirection={'column'}
        style={{ height: '100%' }}
      >
        <Helmet
          title={'The best little homepage on the .sh TLD | brandon paquette'}
        />
        <img height={300} src={Robot} />
      </Flex>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.tsx